import close from '../../common/svg/search-bar/close.svg';
import magGlass from '../../common/svg/search-bar/search.svg';
import styles from './SearchBarInput.module.css';

export interface Props {
  search: string;
  value: string;
}

export const SearchBarInput: React.FC<
  Props & React.HTMLProps<HTMLInputElement> & React.HTMLProps<HTMLDivElement>
> = props => {
  return (
    <div className="flex items-center w-full h-14 relative">
      <img
        className={'absolute left-4 md:top-4 sm:top-3 top-7'}
        width="25px"
        height="25px"
        src={magGlass}
        alt={'magIcon'}
      ></img>
      <input
        className={
          styles.searchInput +
          ' w-full h-14 border-0 outline-none text-left pl-2 md:my-0 sm:mt-0 mt-8 mb-2'
        }
        id="searchBar"
        type="text"
        placeholder="           Search Collections"
        value={props.value}
        onChange={props.onChange}
        onFocus={props.onFocus}
        onBlur={props.onBlur}
      />
      {props.search.length > 0 ? (
        <div
          role="searchbox"
          tabIndex={0}
          aria-hidden="true"
          className={'absolute right-4 md:top-5 sm:top-4 top-8 pointer'}
          onClick={props.onClick}
        >
          <img width="16px" height="16px" src={close} alt={'close'}></img>
        </div>
      ) : null}
    </div>
  );
};
